import { Col, Row } from 'antd';
import classNames from 'classnames/bind';
import { Panel } from 'components/ui/index';
import { objTypeAndClassTypeMap } from 'config/app.config';
import React from 'react';
import { injectIntl } from 'react-intl';
import { Link, withRouter } from 'react-router-dom';
import Enums from 'utils/EnumsManager';
import styles from './index.less';
import CardBackGround from './cardBackGround';

const { ObjectTypes, Recently } = Enums;
const { Leads, Accounts, Opportunities } = ObjectTypes;
const cx = classNames.bind(styles);

const RecentlyTag = ({
  intl,
  leads,
  accounts,
  objects,
}) => {
  const { formatMessage } = intl;
  return (
    <Row gutter={8}>
      <Col span={8} >
        {!_.isEmpty(leads) &&
          <Panel panelClasses={`${objTypeAndClassTypeMap.leads}-sub-panel`} panelTitle={formatMessage({ id: 'page.dashboard.newleads' })}>
            <ul className={cx('links')}>
              { leads.map(l =>
                (
                  <li key={l.id} className={cx('single-link')}>
                    <Link title={l.name} className={`${objTypeAndClassTypeMap.leads}-theme-text`} to={`leads/${l.id}`}>{l.name}</Link>
                  </li>
                ))

              }
            </ul>
          </Panel>
        }
        {_.isEmpty(leads) &&
          <CardBackGround
            type={Leads}
            time={Recently}
            titleText={formatMessage({ id: 'page.dashboard.newleads' })}
          />
        }
      </Col>
      <Col span={8}>
        {!_.isEmpty(accounts) &&
          <Panel panelClasses={`${objTypeAndClassTypeMap.accounts}-sub-panel`} panelTitle={formatMessage({ id: 'page.dashboard.newaccounts' })} >
            <ul className={cx('links')}>
              { accounts.map(l =>
                (
                  <li key={l.id} className={cx('single-link')}>
                    <Link title={l.name} className={`${objTypeAndClassTypeMap.accounts}-theme-text`} to={`accounts/${l.id}`}>{l.name}</Link>
                  </li>
                )) }
            </ul>
          </Panel>
        }
        {_.isEmpty(accounts) &&
          <CardBackGround
            type={Accounts}
            time={Recently}
            titleText={formatMessage({ id: 'page.dashboard.newaccounts' })}
          />
        }
      </Col>
      <Col span={8}>
        {!_.isEmpty(objects) &&
          <Panel panelClasses={`${objTypeAndClassTypeMap.opportunities}-sub-panel`} panelTitle={formatMessage({ id: 'page.dashboard.newObjects' })} >
            <ul className={cx('links')}>
              { objects.map(l => l.exists &&
                (
                  <li key={l.id} className={cx('single-link')}>
                    <Link title={l.name} className={`${objTypeAndClassTypeMap[l.object_type]}-theme-text`} to={`${l.object_type}/${l.id}`}>{l.name}</Link>
                  </li>
                 )) }
            </ul>
          </Panel>
        }
        {_.isEmpty(objects) &&
          <CardBackGround
            type={Opportunities}
            time={Recently}
            titleText={formatMessage({ id: 'page.dashboard.newObjects' })}
          />
        }
      </Col>
    </Row>
  );
};

export default withRouter(injectIntl(RecentlyTag));



// WEBPACK FOOTER //
// ./src/views/Dashboard/components/leftTopModal/recentlyTag.jsx